import React, { useEffect, useState } from "react";
import "./TopButton.css";
import { translate } from "../../i18n";

export default function TopButton() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const update = () => setVisible(window.scrollY > 400);
    update();
    window.addEventListener("scroll", update, { passive: true });
    return () => window.removeEventListener("scroll", update);
  }, []);

  return (
    <button
      type="button"
      id="topButton"
      style={{ visibility: visible ? "visible" : "hidden" }}
      aria-label={translate("Go up")}
      title={translate("Go up")}
      onClick={() =>
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
            .matches
            ? "auto"
            : "smooth",
        })
      }
    >
      <i className="fas fa-arrow-up" aria-hidden="true" />
    </button>
  );
}
